export default __webpack_public_path__ + "fd87e2ff987865292f68e7a02ab5a28d.svg";